var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6592 77.1677L10.5927 41L46.6592 4.83239L82.7257 41L46.6592 77.1677Z",
    stroke: "#B25FFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4025 27.824C40.73 27.824 41.7982 28.1984 42.6071 28.9472C43.416 29.696 43.8205 30.6736 43.8205 31.88C43.8205 32.8368 43.5612 33.8248 43.0427 34.844C42.5449 35.8632 41.8811 36.7576 41.0515 37.5272C40.2218 38.2968 39.3506 38.8168 38.438 39.0872L38.1269 38.5256C39.0188 38.1304 39.7344 37.496 40.2736 36.6224C40.8337 35.7488 41.1137 34.8232 41.1137 33.8456C41.1137 32.5976 40.7403 31.5992 39.9936 30.8504C39.2469 30.0808 38.2513 29.696 37.0068 29.696C35.7623 29.696 34.5904 30.1432 33.4911 31.0376C32.3917 31.932 31.5102 33.128 30.8465 34.6256C30.1827 36.1024 29.8509 37.6832 29.8509 39.368C29.8509 41.1984 30.1309 42.8104 30.6909 44.204C31.2509 45.5976 32.0391 46.6792 33.0555 47.4488C34.0926 48.1976 35.2749 48.572 36.6023 48.572C37.5979 48.572 38.5728 48.364 39.5269 47.948C40.4811 47.5112 41.3522 46.8872 42.1404 46.076L42.8249 46.7624C40.6263 49.5496 38.0231 50.9432 35.0156 50.9432C33.3355 50.9432 31.8836 50.5272 30.6598 49.6952C29.436 48.8632 28.4923 47.74 27.8285 46.3256C27.1855 44.8904 26.864 43.2992 26.864 41.552C26.864 38.9936 27.4241 36.6744 28.5441 34.5944C29.6849 32.4936 31.2198 30.84 33.1488 29.6336C35.0778 28.4272 37.1624 27.824 39.4025 27.824Z",
    fill: "#B25FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8212 29.2904C58.5189 29.6024 56.4447 30.4032 54.5986 31.6928C52.7526 32.9616 51.3007 34.5736 50.2429 36.5288C49.2058 38.4632 48.6872 40.564 48.6872 42.8312C48.6872 44.724 49.0502 46.2216 49.7762 47.324C50.5021 48.4264 51.4563 48.9776 52.6385 48.9776C53.8001 48.9776 54.9098 48.1768 55.9676 46.5752C57.0462 44.9528 57.907 42.8416 58.55 40.2416C59.2137 37.6208 59.5456 34.896 59.5456 32.0672L62.4702 30.9128V47.2616C62.4702 47.844 62.5946 48.312 62.8435 48.6656C63.0924 49.0192 63.4347 49.196 63.8703 49.196C64.2021 49.196 64.5444 49.092 64.897 48.884C65.2496 48.6552 65.5192 48.3848 65.7059 48.0728L66.1415 48.4784C65.8511 49.1232 65.4052 49.664 64.8036 50.1008C64.2021 50.5376 63.5176 50.756 62.7502 50.756C61.7961 50.756 61.0182 50.4232 60.4167 49.7576C59.836 49.092 59.5456 48.1456 59.5456 46.9184V40.9592H59.39C57.8966 47.6152 55.3661 50.9432 51.7985 50.9432C49.9525 50.9432 48.4694 50.2984 47.3494 49.0088C46.2293 47.6984 45.6693 45.9096 45.6693 43.6424C45.6693 41.0424 46.3538 38.5984 47.7227 36.3104C49.0917 34.0224 50.9377 32.1608 53.2608 30.7256C55.5839 29.2904 58.104 28.5104 60.8212 28.3856V29.2904Z",
    fill: "#B25FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 93,
    height: 92.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77a5d156a64245e657cb6a6982b06e31.svg";
export { ForwardRef as ReactComponent };